import Header from './../Component/Header/Header';
import Banner from './../Component/Banner/Banner';
import About from './../Component/About/About';
import Contact from './../Component/Contact/Contact';
import Footer from './../Component/Footer/Footer';
import Projects from './../Component/Projects/Projects';
import Education from './../Component/Education/Education';


import React from 'react';
import Experience from './Experience/Experience';

const Home = () => {

    return (
        <div>
            <Banner></Banner>
            <hr />
            <About></About>
            <Experience></Experience>
            <Projects></Projects>
            <Education></Education>
            <Contact></Contact>
        </div>
    );
};

export default Home;